"use client"
import React, { useContext } from "react";
import styles from "./ProfilePreview.module.css";
import Image from "next/image";
import dayjs from "../../../utils/dayjs";
import Button from "@/components/atoms/Button/Button";
import { OnePageCheckoutContext } from "@/providers/OnePageCheckout.provider";

const GreenStar = "/images/icons/green-star.svg";
const CalendarIcon = "/images/icons/calendar.svg";
const ThunderBoltIcon = "/images/icons/zap.svg";
const TrophyIcon = "/images/icons/trophy.svg";
const LightbulbIcon = "/images/icons/light_bulb.svg";

// USE LUXON FOR DATES. DAY.js needs plugins...

export interface IProfilePreviewProps {
  mentor_name: string;
  headline: string;
  pitch: string;
  credits_per_session: number;
  profile_image_url: string;
  timezone: dayjs.Dayjs;
  awards: AwardsConfig;
  bio?: string;
}

interface AwardsConfig {
  is_fast_responder: boolean;
  mentor_award: string | null;
  review_highlight: string | null;
  next_available_date: string | null;
}

const AwardsContainer = ({ awards }: { awards: AwardsConfig }) => {
  return (
    <ul className={styles.awards}>
      <li>
        <Image
          src={CalendarIcon}
          width={16}
          height={16}
          alt=""
        />
        <p>Available: {awards.next_available_date}</p>
      </li>
      {awards.is_fast_responder && (
        <li>
          <Image
            src={ThunderBoltIcon}
            width={16}
            height={16}
            alt=""
          />
          <p>Fast and consistent responses</p>
        </li>
      )}
      {awards.mentor_award && (
        <li>
          <Image
            src={TrophyIcon}
            width={16}
            height={16}
            // layout="fixed"
            alt=""
          />
          <p>{awards.mentor_award}</p>
        </li>
      )}
      {awards.review_highlight && (
        <li>
          <Image
            src={LightbulbIcon}
            width={16}
            height={16}
            // layout="fixed"
            alt=""
          />
          <p>{awards.review_highlight}</p>
        </li>
      )}
    </ul>
  );
};

const ProfilePreviewComponent = ({
  profile_image_url,
  headline,
  mentor_name,
  pitch,
  awards,
  bio,
}: IProfilePreviewProps) => {
  const { toggleOpen } = useContext(OnePageCheckoutContext);
  return (
    <div className={styles.container}>
      <div className={styles.avatar}>
        <Image
          src={profile_image_url}
          alt={`${mentor_name}'s profile photo`}
          // width={288}
          // height={169}
          fill={true}
        />
      </div>
      <h1>{pitch}</h1>
      <div className={styles.mentor_title}>
        <h3>{mentor_name}</h3>
        <span>{headline}</span>
      </div>
      <p>{bio}</p>
      <p>
        {`Join ${mentor_name}'s private mentorship program to get personalized
          advice that will help scale your business.`}
      </p>
      <div className={styles.desktop_only}>
        <AwardsContainer awards={awards} />
      </div>
      <div className={styles.mobile_only}>
        <AwardsContainer awards={awards} />
      </div>
      <Button style={{ width: "200px" }} onClick={toggleOpen}>Book Now</Button>
    </div>
  );
};

export default ProfilePreviewComponent;
